import React from 'react';
import { useNavigate } from 'react-router';
import moment from 'moment';

import { computeOrderTotal, getOrderComponentClassNames } from '../../helpers/orders';
import { remove as removeOrder } from '../../apis/orders';
import { formatMoney } from '../../helpers/formatters';

import { ConfirmationActionButton } from '../common/buttons/ConfirmationActionButton';
import { ActionButton } from '../common/buttons/ActionButton';
import { LightIcon } from '../common/icons/LightIcon';
import { OrderChildRow } from './OrderChildRow';

export const OrdersListItem = ({ row: order, showChildRow, onShowChildRow, onRefresh }) => {
    const navigate = useNavigate();

    const EditActionButton = (props) => {
        return (
            <ActionButton
                onClick={() => navigate(`/admin/orders/edit/${order.id}`)}
                tooltipText="Edit"
                {...props}
            />
        );
    };

    const RemoveActionButton = (props) => {
        return (
            <ConfirmationActionButton
                confirmationText={`Do you want to remove this order?`}
                notificationTitle="Orders"
                notificationIcon="file-invoice"
                tooltipText="Remove"
                action={() => removeOrder(order.id)}
                onSucceed={onRefresh}
                {...props}
            />
        );
    };

    const orderTotal = computeOrderTotal(order.items, true);

    const {
        itemClassName,
        labelClassName,
        badgeClassName,
        textStartClassName,
        textEndClassName,
        secondaryButtonClassName,
        primaryButtonClassName
    } = getOrderComponentClassNames(order, showChildRow);

    return (
        <React.Fragment>
            <li className={itemClassName}>
                <div className="row">
                    <div className="more-cell col-lg-1 col-xl-1 d-none d-lg-block">
                        <p className="text-center my-1">
                            <button
                                className={secondaryButtonClassName}
                                onClick={() => onShowChildRow(order)}>
                                <LightIcon
                                    icon={showChildRow ? 'minus' : 'plus'}
                                    iconClassName="fa-fw"
                                    color="default"
                                />
                            </button>
                        </p>
                    </div>
                    <div className="date-cell col-lg-2 col-xl-2 d-flex justify-content-between">
                        <label className={labelClassName}>Date</label>
                        <p className={textStartClassName}>
                            {moment(order.date).format('YYYY/MM/DD')}
                        </p>
                    </div>
                    <div className="user-cell col-lg-2 col-xl-2 d-flex justify-content-between">
                        <label className={labelClassName}>User</label>
                        <p className={textStartClassName}>{order.user.name}</p>
                    </div>
                    <div className="status-cell col-lg-2 col-xl-2 d-flex justify-content-between">
                        <label className={labelClassName}>Status</label>
                        <p className={`text-end text-lg-center w-100 my-1`}>
                            <span className={badgeClassName}>{order.status}</span>
                        </p>
                    </div>
                    <div className="total-cell col-lg-2 col-xl-3 d-flex justify-content-between">
                        <label className={labelClassName}>Total</label>
                        <p className={textEndClassName}>{formatMoney(orderTotal)}</p>
                    </div>
                    <div className="actions-cell col-lg-3 col-xl-2 d-flex justify-content-between">
                        <label className={labelClassName}>Actions</label>
                        <p className="text-end w-100 my-1">
                            <EditActionButton className={primaryButtonClassName}>
                                <span className="far fa-edit fa-fw"></span>
                            </EditActionButton>
                            <RemoveActionButton className={primaryButtonClassName}>
                                <span className="far fa-trash fa-fw"></span>
                            </RemoveActionButton>
                        </p>
                    </div>
                    <div className="d-grid d-block d-lg-none my-3 ">
                        <button
                            className={primaryButtonClassName}
                            onClick={() => onShowChildRow(order)}>
                            <LightIcon
                                icon={showChildRow ? 'minus' : 'plus'}
                                iconClassName="fa-fw"
                                color="default"
                            />
                        </button>
                    </div>
                </div>
            </li>
            {showChildRow && <OrderChildRow order={order} />}
        </React.Fragment>
    );
};
